import DocumentServiceCollection from "../DocumentServiceCollection";
import DocumentModel from "@/models/document/DocumentModel";

export default class DocumentCollection extends DocumentServiceCollection {
  model() {
    return DocumentModel;
  }
}
